const exceptionMessageToKey = (message) => message
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/_$/, '');
export default exceptionMessageToKey;
